import { useContext, useEffect } from 'react';
import { SecuritiesContext } from '../SecuritiesContext';
import { SecuritiesAction } from '../SecuritiesProvider.types';

const useSecuritiesMessage = (
  channel: SecuritiesChannel,
  action: SecuritiesAction,
  allowUnsubscribe = true,
) => {
  const { setAction, removeAction } = useContext(SecuritiesContext);

  useEffect(() => {
    if (action) {
      setAction(channel, action);

      return () => {
        if (allowUnsubscribe) {
          removeAction(channel);
        }
      };
    }

    return undefined;
  }, [channel, action, setAction, removeAction, allowUnsubscribe]);
};

export default useSecuritiesMessage;
